import React from 'react'
import { useLocalization } from '@/hooks/localization'

export function localized () {
  return function (Component) { // decorator
    return React.forwardRef((props, ref) => { // wrapper component
      const localization = useLocalization()
      return <Component ref={ref} {...props} {...localization} />
    })
  }
}



// WEBPACK FOOTER //
// ./src/decorators/localized.js